export const ERROR = 'ERROR';

export const FETCHED_INFO = 'FETCHED_INFO';

export const FETCHED_UNCONFIRMED_TXS = 'FETCHED_UNCONFIRMED_TXS';
export const FETCHED_SWAPS = 'FETCHED_SWAPS';
export const TOKEN_SWAPPED = 'TOKEN_SWAPPED';
